// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__1nq-G","info":"Note_info__3Tavk","note":"Note_note__24eN7","actions":"Note_actions__2pXws"};